import React from 'react'

import { connect } from "react-redux"

import { Form } from 'react-form'

import { Card } from 'primereact/card'

import * as userActionCreators from "../actionCreators/user"
import * as appActionCreators from "../actionCreators/app"

import UserTable from '../components/user/user-table'
import UserDetails from '../components/user/user-details'

class User extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isDisplayingDialog: false, // determines whether user details dialog is hidden or shown
      selectedUser: {} // determines what user is selected in the table. It will be highlighted
    }
  }

  componentDidMount() {
    //is invoked immediately after a component is mounted. 
    //Initialization that requires DOM nodes should go here. If you need to load data from a remote endpoint, this is a good place to instantiate the network request.   
    this.props.setLoading(true)
      .then(() => this.props.getUsers())
      .then(() => this.props.setLoading(false))
      .catch((error) => {
        this.props.handleError(error)
          .then(() => this.props.setLoading(false))
      })
  }
   
  

  // this function will be called when the form is submitted successfully
  // the user object passed is in the same structure as the object bound to <Form> values property
  // the object will have been updated based on user input
  formSubmittedSuccessfully = user => {
    // if id exists then we are updating otherwise we are adding
    // use actionCreators that have been injected in as props. This happens when the higher order component connect is used
    if (user.UserId) {
      this.saveUser(user, this.props.updateUser)
    } else {
      this.saveUser(user, this.props.addUser)
    }
  }

  // this function will be called when the form is submitted successfully
  // the user object passed is in the same structure as the object bound to <Form> values property
  // the object will have been updated based on user input
  saveUser = (user, save) => {
    this.props.setLoading(true)
      .then(() => save(user))
      .then(response => {
        // set response in store so global response component can handle response
        /*
            response json structure is:
            {
                "$id":"1",
                "SuccessOutput":null,
                "Success":false,
                "ErrorMessages":{
                    "$id":"2",
                    "$values":[
                        "Name is required"
                    ]
                },
                "WarningMessages":{
                    "$id":"3",
                    "$values":[

                    ]
                }
            }
        */
        this.props.setAjaxResponse(response)
        if (response.data.Success) {
          // close dialog by calling function that has been passed in by containing component
          // this is because the state that determines whether the dialog is showing is in the containing component
          this.closeUserDetails()
        }
      })
      .then(() => this.props.setLoading(false))
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  addUser = () => this.loadAndOpenUserDetails(null)
  selectUser = e => this.loadAndOpenUserDetails(e.data)

  loadAndOpenUserDetails = user => {
    let userId = user ? user.UserId : (this.state.selectedUser ? this.state.selectedUser.UserId : null);
    
    this.props.setLoading(true)
      .then(() => this.props.getUser(userId))
      .then(() => {
        this.setState({ isDisplayingDialog: true, selectedUser: user || {} })
      })
      .then(() => this.props.setLoading(false))
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  closeUserDetails = resetForm => {
    if (resetForm) {
      // reset form to initial state to clear validation errors and bound value
      resetForm()
    }

    this.setState({ isDisplayingDialog: false, selectedUser: {} })
    this.props.clearUser()
  }

  render() {
    // check if current user that is being looked at exists. If not create an empty object to deal with issues that could be caused by client being undefined
    // i.e. when binding to user.Entity.GivenNames there could be issues when client is undefined since we are trying to access a property off of a propery
    let currentUser = this.props.user.currentUser ? this.props.user.currentUser : {}
    let users = this.props.user.users ? this.props.user.users : []
    let isAdd = !currentUser.UserId

    let userTableProps = {
      users: users,
      selectUser: this.selectUser,
      addUser: this.addUser,
      selectedUser: this.state.selectedUser
    }

    return (
      <Card title="Users">
        <UserTable {...userTableProps} />
        {/* values sets the form state. I'm binding to the props which is linked redux so we can update the store and the form will be reflected
        this is useful when needed to clear the form or populating the form from another component
        onSubmit is called when the form has been submitted and has passed validation
        formApi properties can be found at https://react-form.js.org/#/*/}
        <Form values={currentUser} onSubmit={this.formSubmittedSuccessfully}>
          {formApi => {
            let userDetailsProps = {
              currentUser: currentUser,
              isAdd: isAdd,
              submitForm: formApi.submitForm,
              resetForm: formApi.resetAll,
              isDisplayingDialog: this.state.isDisplayingDialog,
              closeUserDetails: this.closeUserDetails,
            }

            return (
              <UserDetails {...userDetailsProps} />
            )
          }}
        </Form>
      </Card>
    )
  }
}

const mapStateToProps = (state) => {
  let { user, auth } = state
  return { user, auth }
}

// this is how to combine actions available
const actionCreators = {
  ...userActionCreators,
  ...appActionCreators,
}

export default connect(mapStateToProps, actionCreators)(User)


// WEBPACK FOOTER //
// ./src/container/User.js